import {
    POST,
    postFile,
    GET
} from "../../index";
export const selectAllCar = (param) => POST("/v1/car/selectAllCar", param);
export const insertCar = (param) => POST("/v1/car/insertCar", param);
export const updateCar = (param) => POST("/v1/car/updateCar", param);
export const deleteCar = (param) => POST("/v1/car/deleteCar", param);
export const batchTransferCar = (param) => POST("/v1/car/batchTransferCar", param);
export const carBindDriver = (param) => POST("/v1/car/carBindDriver", param);
export const carReplaceTerminal = (param) => POST("/v1/car/carReplaceTerminal", param);
export const getCarId = (param) => POST("/v1/car/getCarId", param);
export const uploadCar = (param) => postFile("/v1/getExportExcel/uploadCar", param);

export const queryCarTrajectory = (param) => POST("/v1/car/queryCarTrajectory", param);

export const downLoadCarTemplateFile = () => GET('/v1/getExportExcel/exportCarModel')

export const exportCarXLXS = (param) => GET(`/v1/getExportExcel/exportCar`, param)
export const updateCarId = (param) => POST("/v1/car/updateCarId", param)

export const carPush = (param) => POST("/v1/car/carPush", param)